import {
  createPlayListOnServer,
  getPlayLists,
} from "../../services/dataProvider";
import { Button } from "@mui/material";
import { enqueueSnackbar, closeSnackbar, removeSnackbar } from "./snackActions";
import playListMapper from "./../../utils/mappers/playListMapper";
export const INIT_PLAY_LIST = "INIT_PLAY_LIST";
export const ADD_SONG_TO_PLAYLIST = "ADD_SONG_TO_PLAYLIST";
export const ADD_SONG_TO_PLAYLIST_REQUEST = "ADD_SONG_TO_PLAYLIST_REQUEST";
export const CREATE_PLAYLIST = "CREATE_PLAYLIST";
export function initPlayLists() {
  return (dispatch) => {
    getPlayLists().then((json) => {
      dispatch({ type: INIT_PLAY_LIST, payload: playListMapper(json) });
    });
  };
}
export function createPlayList(playListName) {
  return (dispatch) => {
    dispatch({
      type: "LOADING",
      payload: { context: "playlist/create", loading: true },
    });
    createPlayListOnServer(playListName)
      .then((res) => {
        if (res.status === "success") {
          dispatch({ type: CREATE_PLAYLIST, payload: { playListName } });
          dispatch({
            type: "LOADING",
            payload: {
              context: "playlist/create",
              loading: false,
            },
          });
          dispatch(
            enqueueSnackbar({
              message: "Playlist created successfully.",
              options: {
                key: new Date().getTime() + Math.random(),
                variant: "success",
                autoHideDuration: 5000,
                action: (key) => (
                  <Button onClick={() => dispatch(closeSnackbar(key))}>
                    dismiss me
                  </Button>
                ),
              },
            })
          );
        }
      })
      .catch(() => {
        dispatch({
          type: "LOADING",
          payload: {
            context: "playlist/create",
            loading: false,
          },
        });
        dispatch(
          enqueueSnackbar({
            message:
              "Cannot create playlist.maybe playlist name already existed or your network is disconnected to Eternet",
            options: {
              key: new Date().getTime() + Math.random(),
              autoHideDuration: 5000,
              variant: "error",
              action: (key) => (
                <Button onClick={() => dispatch(closeSnackbar(key))}>
                  dismiss me
                </Button>
              ),
            },
          })
        );
      });
  };
}
export function addSongToPlayList(song, playListKey) {
  return {
    type: ADD_SONG_TO_PLAYLIST,
    payload: { song: song, playListKey },
  };
}
export function addSongToPlayListRequest(playlistName) {
  return {
    type: ADD_SONG_TO_PLAYLIST_REQUEST,
    payload: { playlist: playlistName },
  };
}
